import { Apollo, QueryRef } from 'apollo-angular';
import { Injectable } from '@angular/core';

import { Observable, Subscription, Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class ApolloSuperService {}
